/**
 * @fileoverview GET handler for the "/companies/:company_id/company_rate_limits" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdCompanyRateLimits } from "./constants";
import type { CompanyRateLimitsResult } from "./types";

export const getCompanyRateLimits = reactQueryFetcherAdapter(
  companiesCompanyIdCompanyRateLimits,
  (signal: AbortSignal, companyId: string): Promise<CompanyRateLimitsResult> => {
    return fetch(`/companies/${companyId}/company_rate_limits`, "GET", {}, { signal });
  }
);
